import React from "react";

const Skills = () => {
  return (
    <div style={{ backgroundImage: "url('https://images.unsplash.com/photo-1617900906639-cab7adceb499?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80')" }}>
    <section className="dark:bg-gray-800 dark:text-gray-100">
	<div className="container max-w-5xl px-4 py-12 mx-auto">
		<div className="grid gap-4 mx-4 sm:grid-cols-12">
			<div className="col-span-12 sm:col-span-3">
				<div className="text-center sm:text-left mb-14 before:block before:w-24 before:h-3 before:mb-5 before:rounded-md before:mx-auto sm:before:mx-0 before:dark:bg-violet-400">
					<h3 className="text-3xl font-semibold text-lime-100">SKILLS & PROFICIENCIES </h3>
					<span className="text-sm font-bold tracking-wider uppercase dark:text-gray-400 text-yellow-600">( 2YEARS)</span>
				</div>
			</div>
			<div className="relative col-span-12 px-4 space-y-6 sm:col-span-9">
				<div className="col-span-12 space-y-12 relative px-4 sm:col-span-8 sm:space-y-8 sm:before:absolute sm:before:top-2 sm:before:bottom-0 sm:before:w-0.5 sm:before:-left-3 before:dark:bg-gray-700">
					<div className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-violet-400">
						<h3 className="text-xl font-semibold tracking-wide text-blue-600">C Sharp </h3>
						<time className="text-xs tracking-wide uppercase dark:text-gray-400 text-yellow-500">1 Year</time>
						<p className="mt-3 text-green-300">C #, <span class="text-orange-400">O<span class="text-green-500">O</span><span class="text-blue-400">P</span> </span>  , <span class="text-amber-300">Problem Solving</span> .</p>
					</div>
					<div className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-violet-400">
						<h3 className="text-xl font-semibold tracking-wide text-green-400">Asp.Net</h3>
						<time className="text-xs tracking-wide uppercase dark:text-gray-400 text-yellow-500">1 Year</time>
						<p className="mt-3 text-cyan-400">Asp.net core MVC, Asp.netcore Web API <span class="text-cyan-400">,</span> repository pattern <span class="text-yellow-500">,</span> EF Core <span class="text-yellow-500">&</span> Continiue Learning Dotnet</p>
					</div>
					<div className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-violet-400">
						<h3 className="text-xl font-semibold tracking-wide text-cyan-500">Mern stack</h3>
						<time className="text-xs tracking-wide uppercase dark:text-gray-400 text-yellow-500">2 Year</time>
						<p className="mt-3"><span class="text-cyan-400">Javascript,ReactJs,NextJs,Node Js,Html, Css , Bootstrap , Tailwind css</span>  </p>
					</div>
          <div className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-violet-400">
						<h3 className="text-xl font-semibold tracking-wide text-green-400">Database</h3>
						<time className="text-xs tracking-wide uppercase dark:text-gray-400 text-yellow-500">2 Year</time>
						<p className="mt-3 text-cyan-400">Querie Based Database(MS SQL Server), JSON querying(Array of Object) Based Database(Mongo Db) </p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

    </div>
  );
};

export default Skills;
